module.exports = __webpack_public_path__ + "static/media/1.6b2934ce.png";